import { createContext, useContext, useState, useEffect } from 'react';
import { post, get } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tnt_token');
    if (token) {
      get('/auth/me').then(u => { setUser(u); setLoading(false); }).catch(() => { localStorage.removeItem('tnt_token'); setLoading(false); });
    } else setLoading(false);
  }, []);

  async function login(username, password) {
    const data = await post('/auth/login', { username, password });
    localStorage.setItem('tnt_token', data.token);
    setUser(data.user);
    return data.user;
  }

  function logout() {
    localStorage.removeItem('tnt_token');
    setUser(null);
  }

  return <AuthContext.Provider value={{ user, login, logout, loading, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
